import { render, staticRenderFns } from "./replyDetail.vue?vue&type=template&id=9018f8a6&scoped=true"
import script from "./replyDetail.vue?vue&type=script&lang=js"
export * from "./replyDetail.vue?vue&type=script&lang=js"
import style0 from "./replyDetail.vue?vue&type=style&index=0&id=9018f8a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9018f8a6",
  null
  
)

export default component.exports